// assets/svd-lp-offer-qty.js
// Skapad av Claude Code 2026-08-20 — köp-JS för svd-lp-offer-qty.liquid
// (antalsbaserad engångs-paketväljare på LP:er, t.ex. Hud & Päls 1/2/3 flaskor).
//
// Lägger huvudraden med valt antal + stackens gåvor (_gwp) när antal ≥ min —
// gwp-motorn i SVD Functions gör gåvoraderna gratis och kr-appreglerna sätter
// paketpriset. Gåvostacken ([data-lqo-stack]) startar hidden i markupen och
// visas bara när vald rad kvalificerar — utan JS visas inget gåvolöfte alls
// (hellre inget löfte än ett falskt; ATC:n kräver ändå JS).
(function () {
  'use strict';

  function initBox(box) {
    // Init-vakt (jfr svd-productblock-variant-selector.js: dubbel init = dubbla köp)
    if (box.dataset.lqoInit) return;
    box.dataset.lqoInit = '1';

    var rows = Array.from(box.querySelectorAll('.svd-lqo__row'));
    var atcBtn = box.querySelector('.svd-lqo__atc');
    var stack = box.querySelector('[data-lqo-stack]');
    if (!rows.length || !atcBtn) return;

    var mainId = parseInt(box.dataset.mainId, 10) || 0;
    var minQty = parseInt(box.dataset.minQty, 10) || 2;
    var afterAdd = box.dataset.afterAdd || 'cart';
    var giftIds = [];
    try { giftIds = JSON.parse(box.dataset.giftIds || '[]'); } catch (e) {}

    var defaultBtnText = atcBtn.textContent.trim();

    function selectedQty() {
      var sel = box.querySelector('.svd-lqo__row--selected');
      return sel ? parseInt(sel.dataset.qty, 10) || 0 : 0;
    }

    function updateStack() {
      var qty = selectedQty();
      if (stack) stack.hidden = !(giftIds.length && qty >= minQty);
      // Produktkortet för valt antal (data-lqo-pk = Storlekar-postens antal), övriga döljs
      box.querySelectorAll('[data-lqo-pk]').forEach(function (pk) {
        pk.hidden = parseInt(pk.dataset.lqoPk, 10) !== qty;
      });
    }

    function selectRow(row) {
      rows.forEach(function (r) {
        r.classList.remove('svd-lqo__row--selected');
        r.setAttribute('aria-checked', 'false');
        r.setAttribute('tabindex', '-1');
      });
      row.classList.add('svd-lqo__row--selected');
      row.setAttribute('aria-checked', 'true');
      row.setAttribute('tabindex', '0');
      row.focus();
      updateStack();
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () { selectRow(row); });
      row.addEventListener('keydown', function (e) {
        var idx = rows.indexOf(row);
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectRow(row); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); selectRow(rows[idx + 1] || rows[0]); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); selectRow(rows[idx - 1] || rows[rows.length - 1]); }
      });
    });

    updateStack();

    atcBtn.addEventListener('click', async function () {
      var qty = selectedQty();
      if (!mainId || !qty) return;

      // Inga stämplar på huvudraden — kr-appregeln prissätter på produkt+antal,
      // och gamla LP-rabattvägar (_cart_deal m.fl.) ska inte kunna trigga ovanpå.
      var items = [{ id: mainId, quantity: qty }];
      if (qty >= minQty) {
        giftIds.forEach(function (gid) {
          gid = parseInt(gid, 10);
          if (gid > 0) items.push({ id: gid, quantity: 1, properties: { _gwp: 'true' } });
        });
      }

      atcBtn.disabled = true;
      atcBtn.textContent = 'Lägger till…';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Kunde inte lägga till');

        window.location.href = afterAdd === 'checkout' ? '/checkout' : '/cart';
      } catch (err) {
        console.error('[svd-lqo] Cart error:', err);
        atcBtn.textContent = 'Fel – försök igen';
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = defaultBtnText;
        }, 2500);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-svd-lqo]').forEach(initBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
